export const NAV_CONTENT = 'NAV_CONTENT';
export const NAV_CONTENT_SUCCESS = 'NAV_CONTENT_SUCCESS';
export const NAV_CONTENT_FAILED = 'NAV_CONTENT_FAILED';
export const MEDICAL_QUESTIONNAIRE = 'MEDICAL_QUESTIONNAIRE';
export const MEDICAL_QUESTIONNAIRE_SUCCESS = 'MEDICAL_QUESTIONNAIRE_SUCCESS';
export const MEDICAL_QUESTIONNAIRE_FAILED = 'MEDICAL_QUESTIONNAIRE_FAILED';
export const NEED_ANALYSIS_QUESTIONNAIRE = 'NEED_ANALYSIS_QUESTIONNAIRE';
export const NEED_ANALYSIS_QUESTIONNAIRE_SUCCESS = 'NEED_ANALYSIS_QUESTIONNAIRE_SUCCESS';
export const NEED_ANALYSIS_QUESTIONNAIRE_FAILED = 'NEED_ANALYSIS_QUESTIONNAIRE_FAILED';

export interface MQOrder {
  order: number;
}

export interface MQQuestion extends MQOrder {
  questionKey: string;
  questionText: string;
  answerType: string;
  order: number;
}

export interface MQSection extends MQOrder {
  order: number;
  description: string;
  questions: MQQuestion[];
}

export interface MQContent {
  pages?: {
    description: string;
    pageNumber: number;
    lang?: string;
    criteria: {
      cutOffLimit: number;
      action: string;
    }[];
    sections: MQSection[];
  }[];
  declaration?: string;
  planClass: string;
  lang: string;
}
export interface ContentFragment {
  navContentFetched?: boolean;
  navContentError?: unknown;
  topNav?: unknown;
  sideNav?: unknown;
  footer?: unknown;
  banner?: unknown;
  productFetched?: boolean;
  medicalQuestionnairePending?: boolean;
  medicalQuestionnaireFetched?: boolean;
  medicalQuestionnaireError?: unknown;
  medicalQuestionnaire?: MQContent[];
  needAnalysisQuestionnaireFetched?: boolean;
  needAnalysisQuestionnaireError?: unknown;
  needAnalysisQuestionnaire?: MQContent[];
  acm?: unknown;
  contactUsFetched?: boolean;
  contactUs?: Record<string, unknown>;
  organizationCode?: string;
  organizationName?: string;
  organizationNameInFrench?: string;
  contentRoot?: string;
  whiteLabelRoot?: string;
  needAssistance?: unknown;
  qpi?: unknown;
  mqNotEligible?: { title: string; text: string }[];
  mqLIAScripting?: { title: string; text: string };
  termsAndConditions?: { title: string; text: string }[];
  bill96Consent?: string;
  eligibilityCannotBeDetermined?: unknown;
}

export interface ContentFragmentRequest {
  fragmentLink: string;
  contentRefPrefix: string;
  resolvedWith: string;
  fragmentLinkExtension: string;
}
